import { useLayoutEffect, useRef } from "react";
import { useWindowScroll } from "react-use"
import { useLocation } from 'react-router-dom';
import '../styles/ScrollToTop.css';

export function ScrollToTop() {
    const ref = useRef(null);
    const { y } = useWindowScroll();

    const location = useLocation();

    const scrollTo = () => {
        let element;
        if (location.pathname === '/') {
            element = document.getElementById("inicio-section");
        }
        else {
            element = document.getElementById("hero-section");
        }
        element.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest"
        });
    };

    useLayoutEffect(() => {
        if (y > 200) {
            ref.current.style.display = "flex";
        } else {
            ref.current.style.display = "none";
        }
    }, [y]);

    return (
        <div ref={ref} onClick={scrollTo} className="up-button">
            &#x2191;
        </div>
    );
}